import { NumberInput, NumberInputProps } from "@mantine/core";
import { ReactNode } from "react";

import { useStyles } from "./styles";

type NumInputProps = NumberInputProps & {
  onChange: (value: number) => void;
  label?: ReactNode;
  description?: ReactNode;
  placeholder?: string;
  name: string;
  value?: number;
};

export const NumInput = ({
  onChange,
  label,
  description,
  name,
  value,
  placeholder,
  ...mantineProps
}: NumInputProps) => {
  const { classes } = useStyles();

  return (
    <NumberInput
      placeholder={placeholder}
      description={description}
      label={label}
      size="md"
      value={value}
      onChange={onChange}
      classNames={{ input: classes.input }}
      {...mantineProps}
    />
  );
};
